import {ContextMessage} from '@epic-core/localization';

export default ContextMessage;
